// REQUESTS
export const GET_REQUESTS = "GET_REQUESTS";
export const GET_REQUESTS_SUCCESS = "GET_REQUESTS_SUCCESS";
export const GET_REQUESTS_FAILURE = "GET_REQUESTS_FAILURE";
export const GET_REQUESTS_RESET = "GET_REQUESTS_RESET";
